import { render } from "./SimsSignalsView.vue?vue&type=template&id=4a9e1130"
import script from "./SimsSignalsView.vue?vue&type=script&lang=js"
export * from "./SimsSignalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__